import { __module as ensureObject } from "../../../../../../../_virtual/ensureObject.js";
var hasRequiredEnsureObject;
function requireEnsureObject() {
  if (hasRequiredEnsureObject) return ensureObject.exports;
  hasRequiredEnsureObject = 1;
  (function(module, exports$1) {
    exports$1.__esModule = true;
    exports$1["default"] = ensureObject2;
    function ensureObject2(obj) {
      for (var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        props[_key - 1] = arguments[_key];
      }
      while (props.length > 0) {
        var prop = props.shift();
        if (!obj[prop]) {
          obj[prop] = {};
        }
        obj = obj[prop];
      }
    }
    module.exports = exports$1.default;
  })(ensureObject, ensureObject.exports);
  return ensureObject.exports;
}
export {
  requireEnsureObject as __require
};
//# sourceMappingURL=ensureObject.js.map
